import React, { useEffect, useRef, useState } from "react";
import { Button, HStack, Text, VStack } from "@chakra-ui/react";
let observer;
export const PimcoreLink = (props) => {
    var _a;
    const [id, setId] = useState("pimcore_link" + Math.floor(Math.random() * 1000));
    const [editable, setEditable] = useState(null);
    const [ref, setRef] = useState(null);
    /**
     * Need to decouple our callback from the mutation observer itself.
     * Otherwise, all components this calls back to will work with stale state
     * which is a hassle to avoid
     */
    const mutationCallback = () => {
        if (editable) {
            props.onChange(editable.getValue());
        }
    };
    const mutationCallbackRef = useRef(mutationCallback);
    mutationCallbackRef.current = mutationCallback;
    useEffect(() => {
        if (editable) {
            // Just update
            editable.data = props.link;
            return;
        }
        // @ts-ignore
        const newEditable = new pimcore.document.editables.link(id, "pimcorelink", [], props.link);
        newEditable.setRealName("pimcorelink");
        newEditable.render();
        setEditable(newEditable);
    }, [props.link, editable]);
    useEffect(() => {
        if (ref === null || editable === null) {
            return;
        }
        observer = new MutationObserver(() => mutationCallbackRef.current());
        observer.observe(ref, { attributes: true, childList: true, subtree: true });
        return () => {
            observer.disconnect();
        };
    }, [ref, editable]);
    return (React.createElement(HStack, { alignItems: "center", bg: "gray.100", p: 2, borderRadius: "sm" },
        React.createElement("div", { id: id, ref: setRef, style: { opacity: 0, pointerEvents: "none", width: 0, height: 0 } }),
        React.createElement(VStack, { flex: 1, alignItems: "flex-start", spacing: 0 },
            React.createElement(Text, null, (_a = props.link.text) !== null && _a !== void 0 ? _a : "No Label set"),
            React.createElement(Text, { fontSize: "xs" },
                props.link.linktype ? "(internal) " : "",
                props.link.path)),
        React.createElement(Button, { onClick: () => editable === null || editable === void 0 ? void 0 : editable.openEditor() }, "Edit")));
};
